<template>
  <div class="tests">
    <!-- <el-button type="primary">主要按钮</el-button> -->
    <div class="activeDiv" v-show="activeType" @touchmove.prevent @scroll.prevent>
      <el-row class="activeDivNav">
        <el-col :xs="22" :sm="2" style="text-align: left">
          <img class="images" src="../../assets/logos.png" />
        </el-col>
        <el-col :xs="2" :sm="0">
          <span class="close" @click="myFunction"></span>
        </el-col>
      </el-row>
      <li class="open">
        <p>{{ $t("Head.AboutHicool") }}</p>
      </li>
      <li class="open">
        <p>{{ $t("Head.SummitNews") }}</p>
      </li>
      <li class="open">
        <p>{{ $t("Head.ButlerService") }}</p>
      </li>
      <li class="open">
        <p>{{ $t("Head.Fund") }}</p>
      </li>
      <li class="open">
        <p>{{ $t("Head.BusinessSchool") }}</p>
      </li>
      <li class="open">
        <p>{{ $t("Head.IndustrialPark") }}</p>
      </li>
      <li class="open">
        <p>{{ $t("Head.DataKanban") }}</p>
      </li>
      <div class="activeDivHave">
        <!-- 变更语言按钮 -->
        <div class="activeDivHaves" @click="changeLang('en')" v-if="langType">
          CN 中文
        </div>
        <div class="activeDivHaves" @click="changeLang('zh')" v-else>English</div>
      </div>
      <div class="activeDivText">
        <div class="activeDivTexts">
          {{ $t("Head.login") }}
        </div>
      </div>
    </div>
    <div class="main-1440">
      <el-row>
        <el-col :xs="20" :sm="2" style="text-align: left">
          <img class="images" src="../../assets/logos.png" />
        </el-col>
        <el-col :xs="4" :sm="0">
          <!-- 右边弹出栏 -->
          <ul class="topnav">
            <li style="display: none"><a class="active" href="#home"></a></li>

            <li class="icon">
              <a href="javascript:void(0);" style="font-size: 15px" @click="myFunction">
                <span class="blackBlock"></span>
                <span class="blackBlock"></span>
                <span class="blackBlock"></span>
                <span class="close"></span>
              </a>
            </li>
          </ul>
        </el-col>
        <el-col :xs="0" :sm="16">
          <div class="flex">
            <div class="open hidden-xs-only">
              <p>{{ $t("Head.AboutHicool") }}</p>
            </div>
            <div class="open hidden-xs-only">
              <p>{{ $t("Head.SummitNews") }}</p>
            </div>
            <div class="open hidden-xs-only">
              <p>{{ $t("Head.ButlerService") }}</p>
            </div>
            <div class="open hidden-xs-only">
              <p>{{ $t("Head.Fund") }}</p>
            </div>
            <div class="open hidden-xs-only">
              <p>{{ $t("Head.BusinessSchool") }}</p>
            </div>
            <div class="open hidden-xs-only">
              <p>{{ $t("Head.IndustrialPark") }}</p>
            </div>
            <div class="open hidden-xs-only">
              <p>{{ $t("Head.DataKanban") }}</p>
            </div>
          </div>
        </el-col>
        <el-col :xs="0" :sm="6">
          <div class="flex">
            <div class="inputs hidden-xs-only">
              <el-input v-model="input" :placeholder="$t('Head.placeholder')"></el-input>
            </div>
            <div class="havess hidden-xs-only">
              <!-- 变更语言按钮 -->
              <div class="haves" @click="changeLang('en')" v-if="langType">
                CN 中文
              </div>
              <div class="haves" @click="changeLang('zh')" v-else>English</div>
            </div>
            <div class="textss hidden-xs-only">
              <div class="texts">
                {{ $t("Head.login") }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
  import axios from "axios"
  export default {
    name: "HelloWorld",
    data() {
      return {
        input: "",
        langType: true, //决定显示按钮
        activeType: false, //移动端nav
        userinfo: {},//用户信息
      };
    },
    props: {
      msg: String,
    },
    created: function () {
      // console.log("网页可见区域宽", document.body.offsetWidth)
      // console.log("网页可见区域高", document.body.offsetHeight)
      this.login();//用户登录
    },

    methods: {
      login() {
        let self= this;
        axios.get('/api/jointuserinfo', {
        })
          .then(function (response) {
            if (response.data.code == 0) {

              self.userinfo = response.data.data;
              self.$cookies.set("userinfo", response.data.data);
            }
          })
          .catch(function (error) {
            console.log(error);
          });


      },
      //变更语言
      changeLang(type) {
        this.langType = !this.langType;
        this.$i18n.locale = type;
        this.$cookies.set("lang", type);
        //将语言选择写入cookie
      },
      myFunction() {
        this.activeType = !this.activeType;
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* 顶部nav移动端样式 开始*/
  body {
    margin: 0;
  }

  ul.topnav {
    list-style-type: none;
    margin: 0;
    padding: 0;
    /* overflow: hidden; */
    position: relative;
  }

  ul.topnav li {
    float: left;
  }

  ul.topnav li a {
    display: inline-block;
    color: #f2f2f2;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    transition: 0.3s;
    font-size: 17px;
  }

  ul.topnav li a:hover {
    background-color: #000;
  }

  ul.topnav li.icon {
    display: none;
  }

  @media screen and (max-width: 768px) {
    ul.topnav li:not(:first-child) {
      display: none;
    }

    ul.topnav li.icon {
      float: right;
      display: inline-block;
    }
  }

  @media screen and (max-width: 768px) {
    ul.topnav.responsive {
      position: relative;
    }

    ul.topnav.responsive li.icon {
      position: absolute;
      right: 0;
      top: 0;
    }

    ul.topnav.responsive li {
      float: none;
      display: inline;
    }

    ul.topnav.responsive li a {
      display: block;
      text-align: left;
    }
  }

  .blackBlock {
    display: block;
    background-color: white !important;
    height: 2px !important;
    width: 30px;
    margin-top: 7px;
  }

  .icon .blackBlock:first-child {
    margin-top: 0px;
  }

  .close {
    transition: all 150ms ease-in-out;
    margin-top: 25px;
    margin-right: 15px;
    text-shadow: none !important;
    transform: rotate(45deg);
    display: none;
  }

  .close::before {
    transform: scaleX(1);
    transition-delay: 0.35s;
    background-color: #fff !important;
    margin: -2px 0 0 -14px;
    width: 28px;
    height: 4px;
    transform-origin: 0 50% 0;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    content: "";
    transition: transform 0.3s cubic-bezier(0.77, 0, 0.175, 1);
  }

  .close::after {
    transform: scaleY(1);
    transition-delay: 0.5s;
    background-color: #fff !important;
    margin: -13px 0 0 -2px;
    width: 4px;
    height: 28px;
    transform-origin: 50% 100% 0;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    content: "";
    transition: transform 0.3s cubic-bezier(0.77, 0, 0.175, 1);
  }

  .responsive span {
    opacity: 0;
  }

  .activeDiv .close {
    opacity: 1;
    display: block !important;
  }

  .activeDiv {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: #2c2c2c;
  }

  .activeDiv .open {
    display: block;
    color: #fff;
    padding-right: 0px;
  }

  .activeDivNav {
    background: #000;
  }

  .activeDivHave {

    display: block;
    color: #fff;
    text-align: center;
    margin-top: 13px;
  }

  .activeDivHaves {
    background: #ff00ff;
    border-radius: 4px;
    padding: 5px 15px;
    width: 25%;
    margin: 0 auto;
  }

  .activeDivText {
    display: block;
    color: #fff;
    text-align: center;
    margin-top: 13px;
  }

  .activeDivTexts {
    background: #ff00ff;
    border-radius: 4px;
    padding: 5px 15px;
    width: 25%;
    margin: 0 auto;
  }

  /* 顶部nav移动端样式 结束*/
  .flex {
    display: flex;
    justify-content: space-around;
  }

  .image {
    width: 127px;
    height: 57px;
  }

  .main-1440 {
    /* display: flex; */
    color: #ffffff;

    font-size: 16px;

    font-weight: 600;
    color: #ffffff;
    line-height: 22px;
    /* display: flex; */
    text-align: center;
  }

  .open {
    /* width: 134px; */
    text-align: center;
    margin-top: 13px;
    padding-right: 20px;
  }

  .inputs {
    width: 200px;
    height: 54px;
    background: #030303;
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.05);
    padding-top: 6px;
  }

  .haves {
    width: 57px;
    height: 24px;
    background: #ff00ff;
    border-radius: 4px;

    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
  }

  .texts {
    /* width: 90px;
  height: 32px; */
    background: #ff00ff;
    border-radius: 16px;

    line-height: 30px;
    font-size: 16px;
  }

  .havess {
    padding-top: 19px;
    margin-left: 15px;
  }

  .textss {
    padding-top: 15px;
    margin-left: 15px;
  }
</style>